import capitalize from "lodash/capitalize";
import {FaCheck} from "react-icons/fa6";

import {shortCurrency} from "@/lib/format.tsx";
import {BillingPeriod, Plan} from "@/lib/types/billing.ts";
import {PlanFeatures} from "@/pages/billing/v1/instantCheckout/content.ts";

import styles from "./LegacyPlanBox.module.scss";

interface LegacyPlanBoxProps {
  plan: Plan.Starter | Plan.Essential | Plan.Premium | Plan.Custom;
  price: number;
  period: BillingPeriod;
}

export const LegacyPlanBox = ({plan, price}: LegacyPlanBoxProps) => {
  const content = PlanFeatures[plan];
  if (!content) {
    console.error("invalid plan provided:", plan);
    return null;
  }

  return (
    <div className={styles.box}>
      <div className={styles.title}>
        <h5>{capitalize(plan)}</h5>
        <span className="fs-5 fw-medium d-flex align-items-center">
          <span className="pulseTextH2Bold fs-3 me-1">{shortCurrency(price)}</span>/ mo
        </span>
      </div>
      <ul className={styles.list}>
        {content.map((feature, index) => (
          <>
            {index === 7 && <br />}
            <li key={index}>
              <FaCheck className="me-2 text-success" />
              <span>{feature}</span>
            </li>
          </>
        ))}
      </ul>
    </div>
  );
};
